<template>
  <div class="delete-wrap">
    <div class="delete-dialog-wrap" v-if="isOpen">
      <div class="delete-dialog block">
        <h3 class="pa-5 text-left">確定要送出資料嗎</h3>
        <div class="h4 text-left px-5 pb-5">
          已選擇<span class="danger-01-emphasis--text">{{ lang.display_name }}</span>語系，
          送出將會覆蓋<span class="danger-01-emphasis--text">{{ lang.countries_count }}</span>個國家內容，
          是否確定送出？
        </div>
        <div class="pa-5 text-right">
          <button class="btn w-100px mr-10px" @click="cancelHandler()">
            取消
          </button>
          <button class="btn btn-primary w-100px" @click="submitHandler">
            送出
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      'local',
      'lang',
    ]),
  },
  methods: {
    cancelHandler() {
      this.$emit('update:isOpen', !this.isOpen);
    },
    submitHandler() {
      this.$emit('confirm-submit');
      this.cancelHandler();
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-wrap {
  width: 40px;
  height: 40px;
}

.delete-dialog-wrap {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(209, 208, 208, 0.5);
  z-index: 100;
}
.delete-dialog {
  width: 720px;
  margin: 0 auto;
  margin-top: 288px;
}
</style>
